//封装基于axios的ajax(GET,POST请求)
import { getCurrentOpenPageList } from "../common/loginout";
import axios from "./http";
import store from '../store/index';
export default function ajax(url = "", params = {}, type = "GET") {
  let tokenObj=localStorage.getItem("token");
  if(tokenObj){
      tokenObj=JSON.parse(tokenObj);
  }
const token=tokenObj?"Bearer "+tokenObj.token:"";
const axiosObj={
      BASE_URL: '/api',
      headers: {
         'Content-Type': 'application/json; charset=utf-8',
         Authorization:token
       }
};
const http=axios.create(axiosObj);
    // const openPageList=getCurrentOpenPageList();
    // if(openPageList.length===0&&store.state.isShowMsg===false){  
    //     Message({message:"页面还没加载完，请稍等一会儿"});
    //     return;
    // }
  //1.定义Promise对象
  let promise;
  return new Promise((resolve, reject) => {
    //2. 判断请求方式
    if ("GET" === type) {
      //拼接请求字符串
      let paramsStr = "";
      Object.keys(params).forEach(key => {
        paramsStr += key + "=" + params[key] + "&";
      });
      //过滤最后的&
      if (paramsStr !== "") {
        paramsStr = paramsStr.substr(0, paramsStr.lastIndexOf("&"));
      }
      //完整路径
      url += "?" + paramsStr;
      //发送get请求
      promise = http.get(url);
    } else if ("POST" === type) {
      promise = http.post(url, params);
    } else if ("DELETE" === type) {
      promise = http.delete(url, params);
    }

    //返回请求结果
    promise
      .then(response => {
        //请求成功
        resolve(response);
      })
      .catch(error => {
        //请求失败
        reject(error);
      });
  });
}
